/* Momoria — gift box (bundle style). Behaviour shared by every instance of the section. */
(function () {
function initGiftBoxBundleStyle(section) {
    if (section.dataset.gbInit === 'true') {
      return;
    }

    section.dataset.gbInit = 'true';

    const gallery = section.querySelector('[data-gallery]');

    const gallerySlides = Array.from(
      section.querySelectorAll('[data-gallery-slide]')
    );

    const galleryDots = Array.from(
      section.querySelectorAll('[data-gallery-dot]')
    );

    function activateGalleryDot(index) {
      galleryDots.forEach(function(dot, dotIndex) {
        const isActive = dotIndex === index;

        dot.classList.toggle('is-active', isActive);

        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function moveGalleryToIndex(index) {
      if (!gallery || index < 0) {
        return;
      }

      if (window.innerWidth <= 849) {
        gallery.scrollTo({
          left: gallery.clientWidth * index,
          behavior: 'smooth'
        });
      }

      activateGalleryDot(index);
    }

    if (
      gallery &&
      gallerySlides.length > 1 &&
      galleryDots.length === gallerySlides.length
    ) {
      galleryDots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          moveGalleryToIndex(index);
        });
      });

      let galleryScrollFrame = null;

      gallery.addEventListener(
        'scroll',
        function() {
          if (galleryScrollFrame) {
            cancelAnimationFrame(galleryScrollFrame);
          }

          galleryScrollFrame = requestAnimationFrame(function() {
            const slideWidth = gallery.clientWidth;

            if (!slideWidth) {
              return;
            }

            const calculatedIndex = Math.round(
              gallery.scrollLeft / slideWidth
            );

            const activeIndex = Math.max(
              0,
              Math.min(
                calculatedIndex,
                galleryDots.length - 1
              )
            );

            activateGalleryDot(activeIndex);
          });
        },
        {
          passive: true
        }
      );
    }

    const minusButton = section.querySelector('[data-qty-minus]');
    const plusButton = section.querySelector('[data-qty-plus]');

    const quantityInput = section.querySelector(
      '.mgbx__quantity-input'
    );

    if (minusButton && plusButton && quantityInput) {
      minusButton.addEventListener('click', function() {
        const currentValue = parseInt(
          quantityInput.value || '1',
          10
        );

        quantityInput.value = Math.max(
          1,
          currentValue - 1
        );
      });

      plusButton.addEventListener('click', function() {
        const currentValue = parseInt(
          quantityInput.value || '1',
          10
        );

        quantityInput.value = currentValue + 1;
      });
    }

    const variantInput = section.querySelector(
      '[data-variant-input]'
    );

    const priceOutput = section.querySelector(
      '[data-current-price]'
    );

    const compareOutput = section.querySelector(
      '[data-compare-price]'
    );

    const addButton = section.querySelector(
      '[data-add-button]'
    );

    const variantRadios = Array.from(
      section.querySelectorAll('[data-variant-radio]')
    );

    const addButtonText = section.dataset.addText || 'Add to cart';

    const stickyPrice = section.querySelector(
      '[data-sticky-price]'
    );

    const stickyButton = section.querySelector(
      '[data-sticky-add-button]'
    );

    const stickyButtonText = section.dataset.stickyText || 'Add to cart';

    function updateVariant(selectedRadio) {
      if (!selectedRadio) {
        return;
      }

      const isAvailable =
        selectedRadio.dataset.available === 'true';

      if (variantInput) {
        variantInput.value =
          selectedRadio.dataset.variantId;
      }

      if (
        priceOutput &&
        selectedRadio.dataset.price
      ) {
        priceOutput.textContent =
          selectedRadio.dataset.price;
      }

      if (compareOutput) {
        if (selectedRadio.dataset.comparePrice) {
          compareOutput.textContent =
            selectedRadio.dataset.comparePrice;

          compareOutput.hidden = false;
        } else {
          compareOutput.textContent = '';
          compareOutput.hidden = true;
        }
      }

      if (addButton) {
        addButton.disabled = !isAvailable;

        addButton.textContent = isAvailable
          ? addButtonText
          : 'Sold out';
      }

      if (
        stickyPrice &&
        selectedRadio.dataset.price
      ) {
        stickyPrice.textContent =
          selectedRadio.dataset.price;
      }

      if (stickyButton) {
        stickyButton.disabled = !isAvailable;

        stickyButton.textContent = isAvailable
          ? stickyButtonText
          : 'Sold out';
      }

      const featuredMediaId =
        selectedRadio.dataset.mediaId;

      if (featuredMediaId) {
        const matchingIndex = gallerySlides.findIndex(
          function(slide) {
            return slide.dataset.mediaId === featuredMediaId;
          }
        );

        if (matchingIndex >= 0) {
          moveGalleryToIndex(matchingIndex);
        }
      }

      if (
        window.history &&
        window.history.replaceState
      ) {
        const url = new URL(window.location.href);

        url.searchParams.set(
          'variant',
          selectedRadio.dataset.variantId
        );

        window.history.replaceState(
          {},
          '',
          url.toString()
        );
      }
    }

    variantRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        updateVariant(radio);
      });
    });

    const checkedVariant = section.querySelector(
      '[data-variant-radio]:checked'
    );

    if (checkedVariant) {
      updateVariant(checkedVariant);
    }
  }

  function bootGiftBoxBundleStyle() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-giftbox-bundlestyle]'))
      .forEach(initGiftBoxBundleStyle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      bootGiftBoxBundleStyle
    );
  } else {
    bootGiftBoxBundleStyle();
  }

  /* the Theme Editor re-renders a section without a page load */
  document.addEventListener(
    'shopify:section:load',
    bootGiftBoxBundleStyle
  );
})();